import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import compose from "recompose/compose";
import { NativeSelect, Typography } from "@material-ui/core";
import { EmojiEventsTwoTone } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import EmojiEventsTwoToneIcon from "@material-ui/icons/EmojiEventsTwoTone";
import { getChallengeLeaderboard } from "../../../../../../apis/eventService";
import BoardList from "./BoardList";
import ApplicationConstants from "../../../../../../constants/ApplicationConstants";

function BinaryResponseBoard({ classes, challengeType, isProgram }) {
  const [maleParticipant, setMaleParticipant] = useState([]);
  const [femaleParticipant, setFemaleParticipant] = useState([]);
   const [limitRows, setLimitRows] = useState(
    ApplicationConstants.limitRowsArrayTeamAndIndividual?.[0]?.value,
  );                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        



  useEffect(() => {
    let programChallengeId = challengeType?.id;
    const fetchChallengeData = async () => {
      try {
        const { data } = await getChallengeLeaderboard(programChallengeId , limitRows);
        console.log(data);
        setMaleParticipant(data?.maleRanking || []);
        setFemaleParticipant(data?.femaleRanking || []);
      } catch (error) {
        console.log("error");
      }
    };
    fetchChallengeData();
  }, [challengeType , limitRows]);


    const onLimitChange = (event) => {
    const newLimit = parseInt(event?.target?.value);
    setLimitRows(newLimit);
  
  };

  return (
    <div className={classes.container}>

       <Grid
              item
              xs={12}
              style={{
                padding: "15px 30px 0 0",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-start",
              }}
            >
              <div>
                <label
                  htmlFor=""
                  style={{ color: "#727272", padding: "0 5px" }}
                >
                  Top Participants:
                </label>
                <NativeSelect
                  id="myDropdown"
                  style={{ width: "60px", padding: "0 5px" }}
                  onChange={onLimitChange}
                  value={limitRows}
                >
                  {ApplicationConstants.limitRowsArrayTeamAndIndividual?.map(
                    (v, i) => (
                      <option value={v.value} key={i}>
                        {v.label}
                      </option>
                    ),
                  )}
                </NativeSelect>
              </div>
            </Grid> 
      {challengeType?.programChallengeType !== "MENTAL_WELLBEING" && (
        <Grid item>
          <div className={classes.leaderBoardTitle}>
            <EmojiEventsTwoTone className={classes.leaderBoardIcon} />
            <span className={classes.leaderBoardText}>
              Point Based Leaderboard
            </span>
          </div>

          <div className={classes.leaderboard_maleFemale}>
            {maleParticipant.length > 0 && (
              <div
                className={classes.leaderboard_container}
                style={{
                  flex: femaleParticipant.length > 0 ? "0 1 48%" : "1 1 100%",
                }}
              >
                <div className={classes.container_title}>
                  <EmojiEventsTwoToneIcon
                    style={{
                      color: "rgb(40, 131, 181)",
                      marginBottom: "10px",
                    }}
                  />
                  <span
                    style={{
                      color: "rgb(40, 131, 181)",
                      fontSize: "20px",
                      marginBottom: "10px",
                    }}
                  >
                    Male
                  </span>
                </div>
                <BoardList
                  challangeType={challengeType?.programChallengeType || ""}
                  center
                  data={maleParticipant}
                  gender="MALE"
                  challengeParameter={"PROGRAM_CHALLENGE"}
                />
              </div>
            )}
            {femaleParticipant.length > 0 && (
              <div
                className={classes.leaderboard_container}
                style={{
                  flex: maleParticipant.length > 0 ? "0 1 48%" : "1 1 100%",
                }}
              >
                <div className={classes.container_title}>
                  <EmojiEventsTwoToneIcon
                    style={{
                      color: "rgb(40, 131, 181)",
                      marginBottom: "10px",
                    }}
                  />
                  <span
                    style={{
                      color: "rgb(40, 131, 181)",
                      fontSize: "20px",
                      marginBottom: "10px",
                    }}
                  >
                    Female
                  </span>
                </div>
                <BoardList
                  challangeType={challengeType?.programChallengeType || ""}
                  center
                  data={femaleParticipant}
                  gender="FEMALE"
                  challengeParameter={"PROGRAM_CHALLENGE"}
                />
              </div>
            )}
          </div>

          {maleParticipant.length === 0 && femaleParticipant.length === 0 && (
            <div
              style={{
                textAlign: "center",
                marginTop: "10px",
                fontWeight: 600,
                fontSize: "20px",
                color: "gray",
              }}
            >
              <Typography
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  color: "gray",
                }}
              >
                No Participant.
              </Typography>
            </div>
          )}
        </Grid>
      )}
    </div>
  );
}

const styles = (theme) => ({
  container: {
    width: "90%",
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  leaderboard_maleFemale: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    margin: "0px 10px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  container_title: {
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    marginTop: "20px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "20px",
    },
  },
  leaderboard_container: {
    margin: "0 10px",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      flex: 1,
      width: "100%",
      margin: "0px",
    },
  },
  leaderBoardTitle: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    marginTop: "5px",
  },
  leaderBoardIcon: {
    color: "#F79824",
  },
  leaderBoardText: {
    color: "rgb(40, 131, 181)",
    fontSize: "20px",
  },
});

export default compose(
  withStyles(styles, { withTheme: true }),
  withRouter,
)(BinaryResponseBoard);
